import React from "react";
import { Box, Typography, Card } from "@mui/material";
import { styled } from "@mui/material/styles";
import ContactSalesIcon from "../../assets/icons/ContactSalesIcon.svg"; 
import ContactSupportIcon from "../../assets/icons/ContactSupportIcon.svg";
import CareersIcon from "../../assets/icons/CareersIcon.svg";
import FeedbackIcon from "../../assets/icons/FeedbackIcon.svg";

// Main Container
const ContactUsMainContainer = styled(Box)`
  background-color: #1D00C4;
  text-align: center;
  position: relative;
  overflow: visible;
  margin-bottom: 10vw;
`;

const ContactUsMainCardContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  position: relative;
  flex-wrap: wrap;
  margin-top: 3vw;
  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const ContactUsMainStyledCard = styled(Card)`
  width:20vw ;/*274px */
  height:25vw ;/*350px */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  background: #FFF;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15); 
  text-align: center;
  transform: translateY(20%);
  transition: all 0.3s ease;
  &:hover {
    background-color: #f1f1f1;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.25); 
    border: 2px solid #1D00C4; 
    opacity: 0.95;
    cursor: pointer; 
  }
  @media (max-width: 768px) {
    border-radius: 10px;
    width:22vw ;/*274px */
    height:28vw ;/*350px */
}
`;

const ContactUsMainIconImage = styled("img")`
  width: 10vw;
  height: 8vw;
  margin-bottom: 2vw;/*38px */
  
  @media (max-width: 768px) {
    width: 10vw;
    height: 8vw;
  }
`;

const ContactUsMainTitle = styled("h5")`
  color: #FFF;
  text-align: center;
  font-family: Montserrat;
  font-size: 3.750rem;/*60 */
  font-weight: 600;
  padding-top: 10vw;

  @media (max-width: 768px) {
    font-size: 1.688rem;/*27px */ 
    padding-top: 15vw;
  }
`;

const ContactUsMainSubtitle = styled("h5")`
  color: #FFF;
  text-align: center;
  font-family: Radikal;
  font-size: 1.5rem;/*24 */
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 100% */
  padding-top: 2vw;
  word-wrap: break-word;
  margin: 0 auto;
  @media (max-width: 768px) {
    font-size: 1.063rem;/*17px */
    width: 40%;
    padding-top: 5vw;

  }
  @media (max-width: 425px) {
    width: 50%;
  }
`;
const ContactUsMainCardTitle=styled("span")`
    color: #000;
    text-align: center;
    font-family: Montserrat;
    font-size: 1.875rem;/*30px */
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    @media (max-width: 768px) {
        font-size:0.7rem;/* */
    }
    @media (max-width: 375px) {
        font-size:0.563rem;/*9px */
    }
`;

const cardData = [
  { title: "Contact<br/> Sales", icon: ContactSalesIcon },
  { title: "Contact <br/>Support", icon: ContactSupportIcon },
  { title: "Careers", icon: CareersIcon },
  { title: "Suggestions <br/>& Feedbacks", icon: FeedbackIcon },
];

const MainSection = () => {
  return (
    <ContactUsMainContainer>
      <ContactUsMainTitle>How can we help?</ContactUsMainTitle>
      <ContactUsMainSubtitle>Get in touch and let us know how we can help?</ContactUsMainSubtitle>
      <ContactUsMainCardContainer>
        {cardData.map((item, index) => (
          <ContactUsMainStyledCard key={index}>
            <ContactUsMainIconImage src={item.icon} alt={item.title} />
            <ContactUsMainCardTitle dangerouslySetInnerHTML={{ __html: item.title }} />
          </ContactUsMainStyledCard>
        ))}
      </ContactUsMainCardContainer>
    </ContactUsMainContainer>
  );
};

export default MainSection;
